import { Case } from '../beans/Case';
import { CaseSearch } from '../beans/CaseSearch';
import { Component, OnInit, ViewChild, Host, ViewContainerRef, HostListener, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { Lawyer } from '../beans/Lawyer';
import { Nomenclature } from '../beans/Nomenclature';
import { Person } from '../beans/Person';
import { FrxBaseBean } from '../beans/frxbasebean';
import { Payment } from '../beans/payment';
import { BlockUiService } from '../services/blockui.service';
import { CaseService } from '../services/case.service';
import { NomenclatureService } from '../services/nomenclature.service';
import { ReportService } from '../services/report.service';
import { AuthService } from '../services/auth.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CompleterService, CompleterData } from 'ng2-completer';
import * as FileSaver from 'file-saver';
import { UserPreferencesService } from '../services/user-preferences.service';
import { CASE_COLUMNS_CATALOG, DEFAULT_VISIBLE_COLUMN_NAMES } from '../beans/case-columns-catalog';

@Component({
	selector: 'app-cases',
	templateUrl: './cases.component.html',
	styleUrls: ['./cases.component.scss']
})

export class CasesComponent implements OnInit {

	@ViewChild('editCase') editCaseModal;

	@ViewChild('caseNumberWrapper') caseNumberWrapper!: ElementRef;

	@ViewChild('damageNumberWrapper') damageNumberWrapper!: ElementRef;

	page = {
		number: 0,
		size: 10,
		totalElements: 0,
		totalPages: 0
	};

	selectedSerchCase = new CaseSearch();
	caseList: Array<Case>;
	claimant: Person;
	defendant: Person;

	lawyers: any[] = [];
	selectedLawyerId: number = null;

	traumaTypes: any[] = [];
	selectedTraumaTypeId: number = null;

	vidSluchajList: any[] = [];
	selectedVidSluchajId: number = null;

	// 0 = всички, 1 = само приключени, 2 = само неприключени. Admin-only.
	selectedPrikljuchenoFilter: number = 0;

	// 0 = всички, 1 = дела, 2 = претенции (по vid_sluchaj флаговете). Admin-only.
	selectedDelaPretenciiFilter: number = 0;

	// Сортиране (server-side). null = без сортиране (default ред на бекенда).
	// При клик на label-а на колона пращаме на бекенда ORDER BY и презапитваме —
	// не сортираме само текущата страница.
	sortField: string = null;
	sortDir: 'asc' | 'desc' = 'asc';
	// Сортируеми са само скаларните l.* колони (виж бекенд whitelist-а) — при
	// SELECT DISTINCT не може ORDER BY по join-колони/колекции.
	private readonly sortableColumns = new Set<string>([
		'caseNumber', 'damageNumber', 'claimNumber', 'applicationNumber',
		'date', 'claimDate', 'mjastoPTP', 'mediator', 'percentage',
		'claimCost', 'cost', 'costProperty', 'chastichenIsk'
	]);

	// Ресайз на колони (в рамките на сесията). Ключ = име на колона → ширина px.
	colWidths: { [name: string]: number } = {};
	private resizing: { name: string; startX: number; startWidth: number } = null;
	// След drag за ресайз — отпускането не бива да задейства sort-клика на header-а.
	private suppressSortClick = false;

	// Split-view режим: десният панел показва preview на избран ред.
	// По default включен — повечето потребители ще искат бърз преглед.
	previewPaneOpen: boolean = true;
	selectedCaseForPreview: any = null;
	// След auto-page-flip — кой ред да селектираме (първи / последен) когато
	// новата страница се зареди.
	private pendingSelectAfterPage: 'first' | 'last' | null = null;

	// Active search до 'Създай Дело' — пише се с дебоунс, refresh-ва списъка.
	activeSearchText: string = '';
	private activeSearchTimer: any = null;


	// Каталогът на всички възможни колони се пази в shared файл; реално
	// показваме само онези от prefs.cases.visibleColumns (или всички ако
	// потребителят още не е изборил).
	private readonly allColumns = CASE_COLUMNS_CATALOG.map(c => ({
		// Адаптираме имената към реалните data ключове в Lawsuite DTO-то
		title: c.title,
		name: (c.name === 'nakazatelnoDelo_prokusrorska' || c.name === 'nakazatelnoDelo_zmMvr')
			? 'nakazatelnoDelo'
			: c.name,
		dataType: c.dataType,
		complexDataType: c.complexDataType,
		_key: c.name
	}));

	public caseColumns: any[] = this.allColumns;

	// Кои search-полета мачват кои колони от каталога. Ако потребителят
	// напълни поле, чиято колона не е в неговите prefs — добавяме я най-
	// вдясно с 🔍 marker, за да види резултата в контекст.
	private readonly searchFieldToColumn: { [field: string]: string } = {
		caseNumber: 'caseNumber',
		damageNumber: 'damageNumber',
		criminalCase: 'nakazatelnoDelo',
		prosecutorsNotice: 'nakazatelnoDelo_prokusrorska',
		mvrNumber: 'nakazatelnoDelo_zmMvr',
		enforcementCase: 'izpulnitelnoDelo',
		dataPTP: 'date',
		mjastoPTP: 'mjastoPTP',
		traumaText: 'traumas',
		traumaTypeId: 'traumaType',
		vidSluchajId: 'vidSluchaj',
		claimant: 'claimentList',
		defendant: 'defendantList'
	};

	currentUserId: number;
	currentUserIsAdmin: boolean;

	constructor(
		private vcRef: ViewContainerRef, private blockUi: BlockUiService, private datePipe: DatePipe, private caseService: CaseService,
		private reportService: ReportService,
		private nomenclatureService: NomenclatureService, private authService: AuthService,
		private prefsService: UserPreferencesService, private route: ActivatedRoute, ) {
		this.currentUserId = this.authService.getUserId();
		this.currentUserIsAdmin = this.authService.isUserAdmin();
	}

	ngOnInit() {
		this.caseList = new Array<Case>();
		this.loadTraumaTypes();
		this.loadLawyers();
		this.loadVidSluchaj();

		// Прилагаме user prefs за видими колони. ngOnInit е добро място,
		// защото при login prefs-те още не са заредени; load() ги пуска.
		this.prefsService.load().subscribe(prefs => this.applyColumnPrefs(prefs));
		this.prefsService.prefs$.subscribe(prefs => this.applyColumnPrefs(prefs));

		// ⬇⬇⬇ ПЪРВО ЗАРЕЖДАНЕ
		//this.search(0, this.page.size);

		this.caseService.caseSaved$.subscribe(() => {
			this.search(this.page.number, this.page.size);
		});

		// Deep-link от Dashboard: ?responsible=&prikljucheno=&delaPretencii=&autoSearch=1
		// → попълваме филтрите и изпълняваме търсенето автоматично.
		this.applyQueryParamsAndSearch();
	}

	private applyQueryParamsAndSearch() {
		const qp = this.route.snapshot.queryParams;
		if (!qp || !qp['autoSearch']) {
			return;
		}
		if (qp['responsible'] != null) {
			this.selectedLawyerId = Number(qp['responsible']);
		}
		if (qp['prikljucheno'] != null) {
			this.selectedPrikljuchenoFilter = Number(qp['prikljucheno']);
		}
		if (qp['delaPretencii'] != null) {
			this.selectedDelaPretenciiFilter = Number(qp['delaPretencii']);
		}
		// Изчакваме един tick lawyer-ите/номенклатурите да се заредят, после search
		setTimeout(() => this.search(0, this.page.size), 0);
	}

	onKeydown(event) {
		if (event.key === 'Enter') {
			this.search();
		}
	}

	@HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			this.search();
		}
	}

	private loadTraumaTypes() {
		this.traumaTypes = new Array<Nomenclature>();
		this.nomenclatureService.getTraumaTypes().subscribe(data => {
			this.traumaTypes = data;
		});
	}

	private loadLawyers() {
		this.lawyers = new Array<Lawyer>();
		this.nomenclatureService.getLawyers().subscribe(data => {
			this.lawyers = data;
		});
	}

	private loadVidSluchaj() {
		this.vidSluchajList = new Array<Nomenclature>();
		this.nomenclatureService.getVidSluchaj().subscribe(data => {
			this.vidSluchajList = data;
		});
	}

	private applyColumnPrefs(prefs: any) {
		this.recomputeColumns();
	}

	/**
	 * Сглобява видимите колони от:
	 *   1) prefs.cases.visibleColumns — потребителските настройки
	 *   2) + всяка колона, чиято search-стойност е попълнена, но я няма в prefs
	 *      → markнато с _fromSearch = true (показва се 🔍 в header-а)
	 */
	private recomputeColumns() {
		const prefs = this.prefsService.current();
		const visible = (prefs && prefs.cases && prefs.cases.visibleColumns)
			|| DEFAULT_VISIBLE_COLUMN_NAMES;
		const visibleSet = new Set(visible);

		// Базови колони от prefs — РЕДЪТ в array-а определя приоритета. Картаме
		// име → дефиниция, а не filter-ваме каталога, защото иначе се губи
		// потребителския ред (Preferences позволява ↑/↓ върху видимите).
		const byKey: { [k: string]: any } = {};
		for (const c of this.allColumns) {
			byKey[c._key] = c;
		}
		const baseColumns = (visible as string[])
			.map(name => byKey[name])
			.filter(c => !!c);

		// Колони от запълнени search полета, които НЕ са в prefs
		const search: any = this.selectedSerchCase || {};
		const extraKeys = new Set<string>();
		for (const field of Object.keys(this.searchFieldToColumn)) {
			const v = search[field];
			if (v !== null && v !== undefined && v !== '' && v !== 0) {
				const colKey = this.searchFieldToColumn[field];
				if (!visibleSet.has(colKey)) {
					extraKeys.add(colKey);
				}
			}
		}
		// Адвокат филтър също
		if (this.selectedLawyerId !== null && this.selectedLawyerId !== undefined
				&& !visibleSet.has('lawyer')) {
			extraKeys.add('lawyer');
		}

		const extraColumns = this.allColumns
			.filter(c => extraKeys.has(c._key))
			.map(c => ({ ...c, _fromSearch: true }));

		this.caseColumns = [...baseColumns, ...extraColumns];
	}

	search(page: number = 0, size: number = this.page.size, showBlockUi: boolean = true) {

		if (showBlockUi) {
			this.blockUi.start(this.vcRef);
			this.createSearch();
		}

		// Изчисляваме колоните на всеки search — за да добавим
		// 🔍 marker-нати колони когато търсенето е по поле без видима колона.
		this.recomputeColumns();

		this.caseService.searchCases(this.selectedSerchCase, page, size).subscribe(
			result => {

				// 1️⃣ РЕЗУЛТАТИ
				this.caseList = result.content;

				for (let i = 0; i < this.caseList.length; i++) {
					if (result.content[i].date != null) {
						this.caseList[i].date = this.datePipe.transform(
							new Date(result.content[i].date),
							'dd.MM.yyyy'
						);
					}
					if (result.content[i].claimDate != null) {
						this.caseList[i].claimDate = this.datePipe.transform(
							new Date(result.content[i].claimDate),
							'dd.MM.yyyy'
						);
					}
				}

				// 2️⃣ ⭐ ЕТО ТОВА Е КЛЮЧОВОТО ⭐
				this.page = {
					number: result.number,
					size: result.size,
					totalElements: result.totalElements,
					totalPages: result.totalPages
				};

				// След arrow-driven page flip — селектирай първия/последния
				if (this.pendingSelectAfterPage && this.caseList.length) {
					const idx = this.pendingSelectAfterPage === 'first'
						? 0
						: this.caseList.length - 1;
					this.selectedCaseForPreview = this.caseList[idx];
					this.pendingSelectAfterPage = null;
					setTimeout(() => this.scrollSelectedIntoView(), 0);
				}

				console.log('PAGE UI:', this.page);

				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			}
		);
	}

	createSearch() {
		if (this.claimant && this.claimant.name) {
			this.selectedSerchCase.claimant = this.claimant.name;
		} else {
			this.selectedSerchCase.claimant = '';
		}
		if (this.defendant && this.defendant.name) {
			this.selectedSerchCase.defendant = this.defendant.name;
		} else {
			this.selectedSerchCase.defendant = '';
		}

		this.selectedSerchCase.responsible = this.selectedLawyerId; // <<< ТУК ГО ПОДАВАШ
		this.selectedSerchCase.traumaTypeId = this.selectedTraumaTypeId; // <<< ТУК ГО ПОДАВАШ
		// Вид случай / Приключено / Дела-Претенции UI контролите са admin-only,
		// но самите стойности минават за всеки потребител — иначе deep-link-ът
		// от Dashboard (двоен клик на бар) не филтрира правилно за non-admin
		// (напр. denica). Non-admin няма как да ги SET-не от UI (скрити са),
		// така че по подразбиране остават null/0.
		this.selectedSerchCase.vidSluchajId = this.selectedVidSluchajId;
		this.selectedSerchCase.prikljuchenoFilter = this.selectedPrikljuchenoFilter || 0;
		this.selectedSerchCase.delaPretenciiFilter = this.selectedDelaPretenciiFilter || 0;
		// Сортиране — подаваме на бекенда колоната + посоката (server-side ORDER BY,
		// не само текущата страница).
		this.selectedSerchCase.sortField = this.sortField;
		this.selectedSerchCase.sortDir = this.sortDir;
		// Стрипването на "#" в id става в CaseService.searchCases — централизирано
		// преди всеки post, така че работи независимо от точката на извикване.
	}

	/** Може ли да се сортира по тази колона (само скаларни l.* полета). */
	isSortable(col: any): boolean {
		return !!col && this.sortableColumns.has(col.name);
	}

	/**
	 * Клик на label на колона → сменяме сортирането и презапитваме бекенда от
	 * страница 0. Първи клик = възх., втори по същата колона = низх.
	 */
	toggleSort(col: any) {
		// Току-що приключи drag за ресайз → игнорираме този клик (иначе би
		// задействал сортиране при отпускане на дръжката).
		if (this.suppressSortClick) {
			this.suppressSortClick = false;
			return;
		}
		if (!this.isSortable(col)) {
			return;
		}
		if (this.sortField === col.name) {
			this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
		} else {
			this.sortField = col.name;
			this.sortDir = 'asc';
		}
		this.createSearch();
		this.search(0, this.page.size);
	}

	/** Стартира drag за ресайз на колона (от дръжката в десния край на header-а). */
	startResize(event: MouseEvent, col: any, thEl: HTMLElement) {
		event.stopPropagation();
		event.preventDefault();
		const startWidth = this.colWidths[col.name] || (thEl ? thEl.offsetWidth : 120);
		this.resizing = { name: col.name, startX: event.clientX, startWidth };
	}

	@HostListener('document:mousemove', ['$event'])
	onResizeMove(event: MouseEvent) {
		if (!this.resizing) {
			return;
		}
		const delta = event.clientX - this.resizing.startX;
		this.colWidths[this.resizing.name] = Math.max(50, this.resizing.startWidth + delta);
	}

	@HostListener('document:mouseup')
	onResizeEnd() {
		if (this.resizing) {
			this.resizing = null;
			this.suppressSortClick = true;
		}
	}

	onActiveSearchInput(value: string) {
		this.activeSearchText = value || '';
		if (this.activeSearchTimer) {
			clearTimeout(this.activeSearchTimer);
		}
		const trimmed = this.activeSearchText.trim();

		// Изчистване: ако е празно, рестартираме търсенето без active filter
		if (trimmed.length === 0) {
			this.activeSearchTimer = setTimeout(() => {
				this.claimant = null;
				this.createSearch();
				this.search(0, this.page.size, false);
			}, 200);
			return;
		}

		// Чакаме минимум 2 символа преди да удряме backend-а
		if (trimmed.length < 2) {
			return;
		}

		// Debounce 300ms
		this.activeSearchTimer = setTimeout(() => {
			// Симулираме попълнен ищец чрез фейк Person обект — createSearch()
			// го взима от this.claimant.name. По този начин минаваме през
			// един и същ pipeline като обикновеното търсене.
			this.claimant = { name: trimmed } as any;
			// showBlockUi = false → без "Моля изчакайте" модала; активното
			// търсене трябва да е тихо и бързо.
			this.createSearch();
			this.search(0, this.page.size, false);
		}, 300);
	}

	togglePreviewPane() {
		this.previewPaneOpen = !this.previewPaneOpen;
		if (!this.previewPaneOpen) {
			this.selectedCaseForPreview = null;
		}
	}

	onCaseRowClick(c: any) {
		// Ако pane-ът е изключен — първият клик го пуска и селектира реда.
		// Така потребителят не трябва да чекне toggle-а ръчно: започне ли
		// да кликва по дела, очаквано е да види резюмето.
		if (!this.previewPaneOpen) {
			this.previewPaneOpen = true;
		}
		this.selectedCaseForPreview = c;
	}

	/** Намира ред-елемента по id и го скролва във визия. */
	private scrollSelectedIntoView() {
		if (!this.selectedCaseForPreview) return;
		const id = this.selectedCaseForPreview.id;
		const row = document.querySelector(
			`tr[data-case-id="${id}"]`
		) as HTMLElement | null;
		if (row && typeof row.scrollIntoView === 'function') {
			row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
		}
	}

	/** ArrowDown/ArrowUp навигация. */
	private arrowNavigate(delta: 1 | -1) {
		if (!this.previewPaneOpen || !this.caseList || !this.caseList.length) {
			return;
		}
		const cur = this.selectedCaseForPreview;
		let idx = cur ? this.caseList.findIndex(c => c.id === cur.id) : -1;
		if (idx < 0) {
			// никой не е селектиран — селектирай първия / последния
			idx = delta > 0 ? 0 : this.caseList.length - 1;
			this.selectedCaseForPreview = this.caseList[idx];
			setTimeout(() => this.scrollSelectedIntoView(), 0);
			return;
		}

		const next = idx + delta;
		if (next >= 0 && next < this.caseList.length) {
			this.selectedCaseForPreview = this.caseList[next];
			setTimeout(() => this.scrollSelectedIntoView(), 0);
			return;
		}

		// Извън границата → опит за page flip
		if (delta > 0 && this.page.number < this.page.totalPages - 1) {
			this.pendingSelectAfterPage = 'first';
			this.onPageChange(this.page.number + 1, this.page.size);
		} else if (delta < 0 && this.page.number > 0) {
			this.pendingSelectAfterPage = 'last';
			this.onPageChange(this.page.number - 1, this.page.size);
		}
	}

	clearClaimant() {
		this.claimant = null;
	}
	clearDefendant() {
		this.defendant = null;
	}

	public extractExcel() {
		this.blockUi.start(this.vcRef);
		this.createSearch();

		// Подаваме видимите на екрана колони — бекендът (само за админ) добавя
		// онези от тях, които ги няма в старите фиксирани колони, най-вдясно.
		this.selectedSerchCase.visibleColumns = (this.caseColumns || []).map(c => c._key || c.name);

		this.reportService.executeXLSReport(this.selectedSerchCase).subscribe({
			next: response => {
				this.blockUi.stop();

				const contentDisposition = response.headers.get('Content-Disposition');
				let filename = 'report.xlsx';

				// Извличане на името от хедъра
				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						filename = match[1];
					}
				}

				const blob = new Blob([response.body], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				FileSaver.saveAs(blob, filename);
			},
			error: err => {
				console.log(err);
				this.blockUi.stop();
			}
		});
	}


	public extractExcelTrauma() {
		this.blockUi.start(this.vcRef);
		this.createSearch();

		this.reportService.executeXLSReportTrauma(this.selectedSerchCase).subscribe({
			next: response => {
				this.blockUi.stop();

				const contentDisposition = response.headers.get('Content-Disposition');
				let filename = 'report-trauma.xlsx';

				// Извличане на името от хедъра
				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						filename = match[1];
					}
				}

				const blob = new Blob([response.body], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				FileSaver.saveAs(blob, filename);
			},
			error: err => {
				console.log(err);
				this.blockUi.stop();
			}
		});
	}

	formatDate(dateToFormat): Date {
		if (dateToFormat) {
			if (typeof dateToFormat === 'string' || dateToFormat instanceof String) {
				let dateParts: string[] = dateToFormat.split('.');
				//month is 0-based, that's why we need dataParts[1] - 1
				return new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]), 12, 0, 0, 0);
			}
			return dateToFormat;
		}
		return;
	}

	deleteCase(event: MouseEvent, c: any) {
		if (event) {
			event.stopPropagation();
		}
		if (!this.currentUserIsAdmin) {
			return;
		}
		const label = c && (c.caseNumber || c.damageNumber || ('ID ' + c.id));
		if (!confirm('Сигурни ли сте, че искате да изтриете дело "' + label + '"?')) {
			return;
		}
		if (!confirm('ПОТВЪРДЕТЕ ОТНОВО: Това действие е необратимо. Наистина ли да изтрия дело "' + label + '"?')) {
			return;
		}
		this.blockUi.start(this.vcRef);
		this.caseService.deleteCase(c.id).subscribe(
			() => {
				this.blockUi.stop();
				alert('Делото беше изтрито успешно.');
				this.search(this.page.number, this.page.size);
			},
			error => {
				this.blockUi.stop();
				let msg = 'Грешка при изтриване';
				if (error) {
					if (error.error && error.error.message) {
						msg += ': ' + error.error.message;
					} else if (error.message) {
						msg += ': ' + error.message;
					} else if (error.status) {
						msg += ' (HTTP ' + error.status + (error.statusText ? ' ' + error.statusText : '') + ')';
					}
				}
				alert(msg);
			}
		);
	}

	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}

	/** autocomplete caseNumber  */
	caseNumberSuggestions: string[] = [];

	onCaseNumberChange(value: string): void {
		this.selectedSerchCase.caseNumber = value;

		if (!value || value.length < 2) {
			this.caseNumberSuggestions = [];
			return;
		}

		this.caseService.getCaseNumberSuggestions(value)
			.subscribe(list => this.caseNumberSuggestions = list);
	}

	selectCaseNumber(value: string): void {
		this.selectedSerchCase.caseNumber = value;
		this.caseNumberSuggestions = [];
	}

	/** autocomplete damageNumber  */
	damageNumberSuggestions: string[] = [];

	onDamageNumberChange(value: string): void {
		this.selectedSerchCase.damageNumber = value;

		if (!value || value.length < 2) {
			this.damageNumberSuggestions = [];
			return;
		}

		this.caseService.getDamageNumberSuggestions(value)
			.subscribe(list => this.damageNumberSuggestions = list);
	}

	selectDamageNumber(value: string): void {
		this.selectedSerchCase.damageNumber = value;
		this.damageNumberSuggestions = [];
	}

	clearSearch(): void {
		this.selectedSerchCase = {
			id: null,
			claimant: '',
			defendant: '',
			caseNumber: null,
			damageNumber: null,
			prosecutorsNotice: null,
			dataPTP: null,
			mjastoPTP: null,
			criminalCase: null,
			mvrNumber: null,
			enforcementCase: null,
			traumaType: null,       // dropdown
			traumaTypeName: null,
			traumaText: null,
			uvajeni: false,
			data_suzd_inst_grdelo_ot: null,
			data_suzd_inst_grdelo_do: null,
			responsible: null,
			traumaTypeId: null,
			vidSluchajId: null,
			prikljuchenoFilter: 0,
			delaPretenciiFilter: 0,
			sortField: null,
			sortDir: null
		};

		this.claimant = null;

		this.defendant = null;

		this.selectedLawyerId = null;

		this.selectedTraumaTypeId = null;

		this.selectedVidSluchajId = null;

		this.selectedPrikljuchenoFilter = 0;

		this.selectedDelaPretenciiFilter = 0;

		// Нулираме и сортирането
		this.sortField = null;
		this.sortDir = 'asc';

		// Изчистваме и active search текста + таймера
		this.activeSearchText = '';
		if (this.activeSearchTimer) {
			clearTimeout(this.activeSearchTimer);
			this.activeSearchTimer = null;
		}

	}

	@HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {

		const target = event.target as HTMLElement;

		// ❌ ако пишем в input / textarea → не пречим
		if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
			return;
		}

		// 👉 Ctrl + Enter → Търси
		if (event.ctrlKey && event.key === 'Enter') {
			event.preventDefault();
			this.search();
			return;
		}

		// 👉 Ctrl + Backspace → Clear
		if (event.ctrlKey && event.key === 'Backspace') {
			event.preventDefault();
			this.clearSearch();
			return;
		}

		// 👉 Ctrl + → → Next page
		if (event.ctrlKey && event.key === 'ArrowRight') {
			event.preventDefault();

			if (this.page.number < this.page.totalPages - 1) {
				this.onPageChange(this.page.number + 1, this.page.size);
			}
			return;
		}

		// 👉 Ctrl + ← → Previous page
		if (event.ctrlKey && event.key === 'ArrowLeft') {
			event.preventDefault();

			if (this.page.number > 0) {
				this.onPageChange(this.page.number - 1, this.page.size);
			}
			return;
		}

		// 👉 ArrowDown / ArrowUp (без модификатори) → ред-навигация в
		//    preview-режима, с auto page-flip на краищата.
		if (!event.ctrlKey && !event.altKey && !event.shiftKey
				&& (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
			if (!this.previewPaneOpen) {
				return; // няма preview pane → не пречим на стандартния scroll
			}
			event.preventDefault();
			this.arrowNavigate(event.key === 'ArrowDown' ? 1 : -1);
			return;
		}
	}


	resolveCell(row: any, col: any): any {

		if (!row || !col) {
			return '';
		}

		const value = row[col.name];

		if (value === null || value === undefined) {
			return '';
		}

		// complex object (пример: traumaType.name)
		if (
			col.dataType === 'object' &&
			col.complexDataType &&
			col.complexDataType.displayValue &&
			value[col.complexDataType.displayValue] !== undefined
		) {
			return value[col.complexDataType.displayValue];
		}

		// списък от обекти → join по displayValue ('Иван Петров, Мария Иванова')
		if (col.dataType === 'list' && Array.isArray(value)) {
			const key = col.complexDataType && col.complexDataType.displayValue;
			return value
				.map((it: any) => (key && it ? it[key] : it))
				.filter(v => v !== null && v !== undefined && v !== '')
				.join(', ');
		}

		// currency
		if (col.dataType === 'currency') {
			return typeof value === 'number'
				? value.toFixed(2)
				: value;
		}

		return value;
	}
	onPageChange(page: number, size: number) {
		// ❌ НЯМА blockUi
		// ❌ НЯМА createSearch

		this.search(page, size, false);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent) {
		const target = event.target as HTMLElement;

		// CASE NUMBER
		if (
			this.caseNumberWrapper &&
			!this.caseNumberWrapper.nativeElement.contains(target)
		) {
			this.caseNumberSuggestions = [];
		}

		// DAMAGE NUMBER
		if (
			this.damageNumberWrapper &&
			!this.damageNumberWrapper.nativeElement.contains(target)
		) {
			this.damageNumberSuggestions = [];
		}
	}

}

